<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M12.857 40H4.286A4.287 4.287 0 0 1 0 35.714V4.286A4.287 4.287 0 0 1 4.286 0h8.571a4.287 4.287 0 0 1 4.286 4.286v31.428A4.287 4.287 0 0 1 12.857 40zM40 35.714V4.286A4.287 4.287 0 0 0 35.714 0h-8.571a4.287 4.287 0 0 0-4.286 4.286v31.428A4.287 4.287 0 0 0 27.143 40h8.571A4.287 4.287 0 0 0 40 35.714z" id="5ucg8109ma"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="zka56tpnfb" fill="currentColor">
            <use xlink:href="#5ucg8109ma"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#5ucg8109ma"/>
        <g mask="url(#zka56tpnfb)" fill="currentColor">
            <path d="M0 0h40v40H0z"/>
        </g>
    </g>
</svg>
